import { connect } from 'react-redux';
import RefinanceView from './RefinanceView';
import { selectedGoalSelector } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import RouteDictionary from '../../WhatIfsRouteDictionary';
import { isNumeric } from '../../../../js/app/react/validators';

import {
  updateWhatIfsData,
  applyWhatIf,
  fetchWhatIfOptions,
  planImpact,
  initialPlanImpact,
} from '../../WhatIfsActions';

import {
  loading,
  nullableFpIdSelector,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  impactSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  areOptionsLoaded,
} from '../../WhatIfsSelector';

import {
  options,
  selectedRefinanceValueSelector,
  debtTitle,
  interestRateSelector,
} from './RefinanceSelector';

const mapStateToProps = (state, ownProps) => ({
  selectedRefinanceValue: selectedRefinanceValueSelector(state, ownProps),
  fpId: nullableFpIdSelector(state, ownProps),
  goal: selectedGoalSelector(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  loading: loading(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  options: options(state, ownProps),
  label: debtTitle(state, ownProps),
  interestRate: interestRateSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  saveStrategy: (clientId, goalId, whatIfType, value) => {
    const WhatIf = {
      Term: value,
    };
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, { WhatIf }));
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(planImpact(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(initialPlanImpact(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
  fetchData: (clientId, fpId, goalId, whatIfType) => {
    dispatch(fetchWhatIfOptions(clientId, fpId, goalId, RouteDictionary[whatIfType], whatIfType));
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    dispatch(applyWhatIf(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
  updateInterestRate: (clientId, goalId, whatIfType, value) => {
    if (isNumeric(value)) {
      dispatch(updateWhatIfsData(clientId, goalId, whatIfType, {
        WhatIf: {
          InterestRate: +value / 100,
        },
      }));
    }
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RefinanceView);
